import { Paper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { COLUMN_WIDTH } from "./appointment-schedule.constants.js";
const ScheduleWrapper = styled(Paper, {
  shouldForwardProp: (props) => props !== "isExtended"
})(
  ({ theme }) => `
  display: flex;
  overflow: auto;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${theme.palette.common.white};
  border-radius: 0;
  width: 100%;
  scrollbar-width: none;
  -ms-overflow-style: none;
 
  ::-webkit-scrollbar {
    display: none;
  }
 `
);
const ScheduleHeaderWrapper = styled("div", {
  shouldForwardProp: (props) => props !== "isExtended"
})(
  () => `
  display: flex;
  position: relative;
  z-index: 4;
  width: 100%;
`
);
const ScheduleContentWrapper = styled("div", {
  shouldForwardProp: (props) => props !== "isExtended"
})(
  () => `
  display: flex;
  height: 100%;
  min-width: 100%;
`
);
const ScheduleDayHeader = styled("div", {
  shouldForwardProp: (props) => props !== "isActive" && props !== "width"
})(
  ({ theme, isActive, width }) => `
  background: ${isActive ? theme.palette.primary[75] : theme.palette.common.white};
  text-align: center;
  height: 40px;
  min-width: 80px;
  width: ${width ? `${width}%` : "100%"};
  padding: 0 4px;
  box-sizing: border-box;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.palette.primary[900]};
  flex-shrink: 0;
  border: 1px solid ${isActive ? theme.palette.primary[75] : theme.palette.grey[300]};
 `
);
const ScheduleEmployeeHeader = styled("div", {
  shouldForwardProp: (props) => props !== "isExtended" && props !== "width"
})(
  ({ theme, width }) => `
  width: ${width ? `${width}%` : `${COLUMN_WIDTH}px`};
  height: 56px;
  margin: 0;
  padding: 8px 4px;
  box-sizing: border-box;
  background: ${theme.palette.common.white};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  flex-shrink: 0;
  flex-grow: 0;
  outline: 1px solid ${theme.palette.grey[300]};
  position: relative;
  z-index: 3;
  overflow: hidden;
 `
);
const ScheduleEmployeesWrapper = styled("div", {
  shouldForwardProp: (props) => props !== "isDayView"
})(
  ({ theme, isDayView }) => `
  display: flex;
  background: ${theme.palette.common.white};
  min-width: ${isDayView ? "100%" : "initial"};
 `
);
const ScheduleDayWrapper = styled("div", {
  shouldForwardProp: (props) => props !== "width" && props !== "minWidth" && props !== "isContentWrapper"
})(
  ({ width, minWidth, isContentWrapper }) => `
  width: ${width}%;
  min-width: ${minWidth ? `${minWidth}px` : "initial"};
  display: ${isContentWrapper ? "flex" : "block"};
`
);
const AvatarWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  flexShrink: 0,
  flexGrow: 0,
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  color: theme.palette.grey[800]
}));
const EmployeeName = styled(Typography)(({ theme }) => ({
  maxWidth: "120px",
  marginLeft: "8px",
  color: theme.palette.grey[800]
}));
const EmployeeWorkingTimes = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isExtended"
})(
  ({ theme, isExtended }) => `
  color: ${theme.palette.grey[700]};
  marginTop: ${isExtended ? 6 : 0}px;
 `
);
const InnerWrapper = styled("div")`
  display: flex;
  width: 100%;
  position: relative;
`;
const Wrapper = styled("div")`
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
`;
const TimelineWrapper = styled(Paper, {
  shouldForwardProp: (props) => props !== "offset"
})(
  ({ theme, offset }) => `
    width: 49px;
    flex-shrink: 0;
    text-align: center;
    border-radius: 8px 0 0 8px;
    background: ${theme.palette.common.white};
    overflow: hidden;
    padding-top: ${offset ?? 0}px;
 `
);
export {
  AvatarWrapper,
  EmployeeName,
  EmployeeWorkingTimes,
  InnerWrapper,
  ScheduleContentWrapper,
  ScheduleDayHeader,
  ScheduleDayWrapper,
  ScheduleEmployeeHeader,
  ScheduleEmployeesWrapper,
  ScheduleHeaderWrapper,
  ScheduleWrapper,
  TimelineWrapper,
  Wrapper
};
